import { SVGProps } from "react";

const UserRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={22}
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.5 11C12.2614 11 14.5 8.76142 14.5 6C14.5 3.23858 12.2614 1 9.5 1C6.73858 1 4.5 3.23858 4.5 6C4.5 8.76142 6.73858 11 9.5 11Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.909912 21C0.909912 17.13 4.75991 14 9.49991 14C10.4599 14 11.3899 14.13 12.2599 14.37"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 17C19.5 17.32 19.46 17.63 19.38 17.93C19.29 18.33 19.13 18.72 18.92 19.06C18.23 20.22 16.96 21 15.5 21C14.47 21 13.54 20.61 12.84 19.97C12.54 19.71 12.28 19.4 12.08 19.06C11.71 18.46 11.5 17.75 11.5 17C11.5 15.92 11.93 14.93 12.63 14.21C13.36 13.46 14.38 13 15.5 13C16.68 13 17.75 13.51 18.47 14.33C19.11 15.04 19.5 15.98 19.5 17Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5299 15.9404L14.4199 18.0504"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.4399 15.9609L16.5599 18.0709"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default UserRemove;
